export enum RoomMemberRole {
  ADMIN = 'ADMIN',
  PARTICIPANT = 'PARTICIPANT',
  READER = 'READER',
}
